import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export function useAdmin() {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [checkedUserId, setCheckedUserId] = useState<string | null>(null);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    if (authLoading) return;

    if (!user) {
      setIsAdmin(false);
      setCheckedUserId(null);
      setChecking(false);
      return;
    }

    if (checkedUserId === user.id) return;

    let cancelled = false;
    setChecking(true);

    supabase.rpc('has_role', { _user_id: user.id, _role: 'admin' }).then(({ data, error }) => {
      if (cancelled) return;
      setIsAdmin(!error && !!data);
      setCheckedUserId(user.id);
      setChecking(false);
    });

    return () => { cancelled = true; };
  }, [user, authLoading, checkedUserId]);

  const loading = authLoading || (!!user && checkedUserId !== user.id) || checking;

  return { user, isAdmin, loading };
}
